type ReducerState = {
  items: Array<Omit<Notifications.Item, 'position'>>
}

export const initialState: ReducerState = {
  items: [],
}

const createItemWithId = (() => {
  let id = 1
  return (item) => ({
    ...item,
    id: id++,
  })
})()

export const addNotification = (state: ReduxState, item: Omit<Notifications.StoreItem, 'id'>): ReducerState => (
  { items: [ ...state.items, createItemWithId(item) ] }
)

export const removeNotification = (state: ReduxState, id): ReducerState => (
  { items: state.items.filter((item) => item.id !== id) }
)

export const resetNotification = (): ReducerState => initialState
